import { render, staticRenderFns } from "./OrdersRefundedShopify.vue?vue&type=template&id=04beaf12&scoped=true"
import script from "./OrdersRefundedShopify.vue?vue&type=script&lang=js"
export * from "./OrdersRefundedShopify.vue?vue&type=script&lang=js"
import style0 from "./OrdersRefundedShopify.vue?vue&type=style&index=0&id=04beaf12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04beaf12",
  null
  
)

export default component.exports